import React, { useEffect, useState } from 'react'
import { Router, Route, Link, Switch } from "react-router-dom";
import { Vendorlookup, UserProfile, UserLogin, About, UserSignup, UserFavourite, EventVendors, WeddingVendors, ProjectGallery, Homeuser, UserVerify, Resetpw, Faq, Beyond, UserQuote, UserBoard, UserQuestion, Blog, Bpage, Notfound, Pricelist, Pricelistlookup, EventDiscovery, Tools, Invitationlookup, Guestbookv1, Guestbook, Projectlookup, Inbox, Planning, Qredit, Invitationedit, Seatchartedit, Guestbookv1edit, Market, Marketlookup, Jmap, Sclookup, Guestbookv1cast, Guestbookv1mod, Guestbookv1lookup, Qrlookup, Itinerarylookup, Comparevenue,Etsyguestbook, Guestbookedit, Collection, Guestbookhowitworks } from './pages' //Bulletsend, Bulletmonitor, Timelinelookup
import { NAVBAR_ICON, EMPTY, SS_LINE, production, STARTUP_NAME, transactionandquote, marketbool } from './config/constants'
import { Loading, refresh, Checkdevice, Portalmodal } from './components';
import { USER_VALIDATE } from './config/api';
import axios from 'axios'

// START OF GA
import ReactGA from "react-ga4";
import { createBrowserHistory } from 'history'
import { Retrieve_personal_info, iconwrapper } from './config/commonfunctions';

// CSS
import Itineraryedit from './pages/Main/Planning/Itinerarymaker/Itineraryedit/Itineraryedit';
import Checklistedit from './pages/Main/Planning/Checklistmaker/Checklistedit/Checklistedit';
import Budgetedit from './pages/Main/Planning/Budgetmaker/Budgetedit/Budgetedit';
import { Helmet } from 'react-helmet';
import { APP_ICON, BLOG_ICON, BOARD_ICON, FAQ_ICON, HEARTUSERLOGIN_ICON, THICKHEART_ICON, HOME_ICON, MSG_ICON, PROFILE_ICON, WEAVEBLISS_WHITE } from './config/svgicons';
import ScreenRecorder from './config/ScreenRecorder';
import Guestbooklookup from './pages/Guestbooklookup/Guestbooklookup';
import Gif from './pages/Collection/ads/Gif/Gif';
import './App.css'

const LOADING = 0
const LOGGED = 1
const LOGOUT = 2

// const TOPLEFTNAV_DIV = <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center', alignItems: 'center' }}  >
//     <Link id='navbar_homelink' style={{ position: 'absolute', display: 'none' }} to="/" />
//     <div onClick={() => document.getElementById('navbar_homelink').click()} style={{ minHeight: 33, minWidth: 33, position: 'relative', display: 'flex', placeContent: 'center', alignItems: 'center', margin: '0px 3px', cursor: 'pointer' }}>
//         {iconwrapper(WEAVEBLISS_WHITE, { width: 27, height: 27, color: '#ffffff' })}
//     </div>
//     <div onClick={() => document.getElementById('navbar_homelink').click()} className="headertitlelogorealtextmobile" >{STARTUP_NAME}</div>
// </div>

const homebtnclick = () => {
    window.open("https://weavebliss.com", "_blank", "noopener,noreferrer");
}

const TOPLEFTNAV_DIV = <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center', alignItems: 'center' }}  >
    <div onClick={homebtnclick} style={{ minHeight: 33, minWidth: 33, position: 'relative', display: 'flex', placeContent: 'center', alignItems: 'center', margin: '0px 3px', cursor: 'pointer' }}>
        {iconwrapper(WEAVEBLISS_WHITE, { width: 27, height: 27, color: '#ffffff' })}
    </div>
    <div onClick={homebtnclick} className="headertitlelogorealtextmobile" >{STARTUP_NAME}</div>
</div>

const history = createBrowserHistory()
production ? ReactGA.initialize('UA-150353866-1') : ReactGA.initialize('1');
// history.listen((location, action) => { ReactGA.pageview(location.pathname + location.search) });
ReactGA.send({
    hitType: "pageview",
    page: location.pathname + location.search,
    title: "Custom Title"
});

const videorecord_for_socialmedia = false

function App() {

    const [auth, setAuth] = useState(LOADING) // 0 - LOADING, 1 - LOGGED, 2 - LOGOUT
    const [token, setToken] = useState('')
    const [id, setId] = useState('')
    const [usertype, setUsertype] = useState('') // Wedding | Event | Guest
    const [menugate, setMenugate] = useState(false) // menu modal gate for mobile
    const [hidetop, setHidetop] = useState(null)
    const device = Checkdevice()

    useEffect(() => {
        let isMounted = true

        // --- Storage listener (with cleanup) ---
        const handleStorageChange = (s) => { if (s.key === 'token') refresh() }
        window.addEventListener("storage", handleStorageChange, false)

        // --- Analytics (no need to delay this) ---
        try {
            const params = new URLSearchParams(window.location.search)
            const source = params.get('s')
            const medium = params.get('m')
            const campaign = params.get('c')

            if (source || medium || campaign) {
                ReactGA.send({
                    hitType: 'pageview',
                    page: window.location.pathname + window.location.search,
                    source: { i: 'instagram', th: 'thread', f: 'facebook', tt: 'tiktok', y: 'youtube', p: 'pinterest', l: 'linkedin' }[source],
                    medium: { s: 'social' }[medium],
                    campaign: { smc: 'social_media_campaign' }[campaign],
                })
            }
        } catch (e) {
            console.warn('Analytics error:', e)
        }

        // --- Token validation ---
        const validateToken = async () => {
            try {
                const { token, _id, acct_type } = Retrieve_personal_info()

                if (!token || token === 'NONE' || token === EMPTY) {
                    if (isMounted) logout(0)
                    return
                }

                if (isMounted) setToken(token)

                // Validate against server
                const response = await axios({
                    method: 'POST',
                    url: USER_VALIDATE,
                    headers: { 'Authorization': 'Bearer ' + token },
                    data: { id: _id }
                })

                if (!isMounted) return
                const res = response.data

                if (res.error) {
                    logout(1)
                    return
                }

                if (acct_type === 'USER') {
                    const { usertype } = res.user
                    const { fev } = res
                    setId(_id)
                    setUsertype(usertype)
                    setAuth(LOGGED)
                    localStorage.setItem("token", 'JWT ' + token)    // re-add prefix when storing back

                    // Reload if frontend version changed
                    const cachedFev = localStorage.getItem('fev') || ''
                    if (fev !== cachedFev) {
                        localStorage.setItem('fev', fev)
                        window.location.reload(true)
                    }
                } else {
                    logout(2)
                }

            } catch (e) {
                console.error('Token validation error:', e)
                if (isMounted) logout(3)
            }
        }
        validateToken()

        return () => {
            isMounted = false
            window.removeEventListener("storage", handleStorageChange)
        }
    }, [])

    const logout = (item) => {
        window.removeEventListener("storage", () => { refresh() }, false)
        setMenugate(false)
        setAuth(LOGOUT)
        setToken('')
        setId('')
        localStorage.token = EMPTY
    }

    const goblog = () => {
        window.open("https://blog.weavebliss.com", "_blank")
    }

    const hidetopbar = (g) => { setHidetop(g) }

    const offdialog = (e) => {
        e.stopPropagation();
        setMenugate((prevState) => { return !prevState })
    }

    const NavbarHeader = () => {

        const loggedmenuG_mobile = { // guest
            'Home': { link: '/' },
            'Profile': { link: '/profile' },
            'FAQ': { link: '/faq', style: { borderRight: '1px solid white' } },
            'Blog': { link: "#", func: goblog },
            // 'Logout': { link: '/', func: logout },
        }

        const loggedmenuWE_mobile = !transactionandquote
            ? { // wedding and event
                'Home': { link: '/', icon: HOME_ICON },
                // 'Favourite': { link: '/favourite/vendor', icon: THICKHEART_ICON },
                // 'Board': { link: '/board', icon: BOARD_ICON },
                'Profile': { link: '/profile', icon: PROFILE_ICON },
                'Inbox': { link: '/chat', icon: MSG_ICON },
                'FAQ': { link: '/faq', style: { borderRight: '1px solid white' }, icon: FAQ_ICON },
                // 'Blog': { link: '/blog' },
                'Blog': { link: "#", func: goblog, icon: BLOG_ICON },
                // 'Logout': { link: '/', func: logout },
            }
            : { // wedding and event
                'Home': { link: '/', icon: HOME_ICON },
                // 'Favourite': { link: '/favourite/vendor', icon: THICKHEART_ICON },
                // 'Board': { link: '/board', icon: BOARD_ICON },
                'Profile': { link: '/profile', icon: PROFILE_ICON },
                'Transaction': { link: '/transaction', icon: MSG_ICON },
                'Inbox': { link: '/chat', icon: MSG_ICON },
                'FAQ': { link: '/faq', style: { borderRight: '1px solid white' }, icon: FAQ_ICON },
                // 'Blog': { link: '/blog' },
                'Blog': { link: "#", func: goblog, icon: BLOG_ICON },
                // 'Logout': { link: '/', func: logout },
            }

        const loggedmenuG = { // guest
            // 'Blog': { link: '/blog' },
            'Blog': { link: "#", func: goblog },
            'FAQ': { link: '/faq', style: { borderRight: '1px solid white' } },
            'Home': { link: '/' },
            'Profile': { link: '/profile' },
            // 'Logout': { link: '/', func: logout },
        }

        const loggedmenuWE = !transactionandquote
            ? { // wedding and event and without transaction
                // 'Blog': { link: '/blog' },
                'Blog': { link: "#", func: goblog, icon: BLOG_ICON },
                'Tools': { link: '/tools', icon: APP_ICON },
                'FAQ': { link: '/faq', style: { borderRight: '1px solid white' }, icon: FAQ_ICON },
                'Home': { link: '/', icon: HOME_ICON },
                'Inbox': { link: '/chat', icon: MSG_ICON },
                // 'Favourite': { link: '/favourite/vendor', icon: THICKHEART_ICON },
                // 'Board': { link: '/board', icon: BOARD_ICON },
                'Profile': { link: '/profile', icon: PROFILE_ICON },
                // 'Logout': { link: '/', func: logout },
            }
            : { // wedding and event and  with transaction
                // 'Blog': { link: '/blog' },
                'Blog': { link: "#", func: goblog, icon: BLOG_ICON },
                'Tools': { link: '/tools', icon: APP_ICON },
                'FAQ': { link: '/faq', style: { borderRight: '1px solid white' }, icon: FAQ_ICON },
                'Home': { link: '/', icon: HOME_ICON },
                'Transaction': { link: '/transaction', icon: MSG_ICON },
                'Inbox': { link: '/chat', icon: MSG_ICON },
                // 'Favourite': { link: '/favourite/vendor', icon: THICKHEART_ICON },
                // 'Board': { link: '/board', icon: BOARD_ICON },
                'Profile': { link: '/profile', icon: PROFILE_ICON },
                // 'Logout': { link: '/', func: logout },
            }

        const unloggedmenu = marketbool
            ? {
                'Tools': { link: '/tools' },
                'Market': { link: '/market' },
                // 'Blog': { link: '/blog' }, 
                'Blog': { link: "#", func: goblog },
                'FAQ': { link: '/faq', style: { borderRight: '1px solid white' } },
                // 'About' : { link: '/about' }, 
                'Sign Up': { link: '/signup' },
                'Login': { link: '/' },
            }
            : {
                'Tools': { link: '/tools' },
                // 'Market': { link: '/market' },
                // 'Blog': { link: '/blog' },  
                'Blog': { link: "#", func: goblog },
                'FAQ': { link: '/faq', style: { borderRight: '1px solid white' } },
                // 'About' : { link: '/about' }, 
                'Sign Up': { link: '/signup' },
                'Login': { link: '/' },
            }

        const iconcss = { width: 20, height: 20, display: 'flex', placeContent: 'center', color: '#fff' }
        const mobileiconcss = { width: 20, height: 20, display: 'flex', placeContent: 'center', color: 'var(--maindark)', margin: '0px 10px 0px 30px' }

        if (device === 'WEB') { // web
            return <div className='app_navroot'>
                {TOPLEFTNAV_DIV}
                <div className='app_navright'>
                    {auth === LOGGED
                        ? usertype === 'Guest'
                            ? Object.keys(loggedmenuG).map((key, index) => {
                                const { link, func, style } = loggedmenuG[key]
                                return <button className='navtopbaritem' key={key + index} style={{ ...style }} onClick={() => document.getElementById(key).click()}>
                                    <Link id={`${key}`} to={link} style={{ visibility: 'hidden' }} onClick={func} />
                                    {key}
                                </button>
                            })
                            : (usertype === 'Event' || usertype === 'Wedding')
                                ? Object.keys(loggedmenuWE).map((key, index) => {
                                    const { link, func, style, icon } = loggedmenuWE[key]
                                    return <button className='navtopbaritem' key={key + index} style={{ ...style }} onClick={() => document.getElementById(key).click()}>
                                        <Link id={`${key}`} to={link} style={{ visibility: 'hidden' }} onClick={func} />
                                        {iconwrapper(icon, iconcss)}
                                    </button>
                                    // return <button className='navtopbaritem' key={key + index} style={{ ...style }} onClick={() => document.getElementById(key).click()}>
                                    //     <Link id={`${key}`} to={link} style={{ visibility: 'hidden' }} onClick={func} />
                                    //     {key}
                                    // </button>
                                })
                                : null
                        : Object.keys(unloggedmenu).map((key, index) => {
                            const { link, func, style } = unloggedmenu[key]
                            return <button className='navtopbaritem' key={key + index} style={{ ...style }} onClick={() => document.getElementById(key).click()}>
                                <Link id={`${key}`} to={link} style={{ visibility: 'hidden' }} onClick={func} />
                                {key}
                            </button>
                        })}
                </div>
            </div>
        }
        else { // mobile
            // const login_m_about_unauth = <Link key={'login_m_about_unauth'} to="/about" onClick={offdialog} style={{ width: '100%', letterSpacing: 1, color: GENERAL_GREY, display: 'flex', justifyContent: 'flex-start', fontWeight: 400, fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', lineHeight: '1.16667em', padding: '15px 0px 15px 10px' }}><div style={{ justifyItems: 'flex-start' }}>About</div></Link>
            const SidelistIcon = <button className="app_navbaricon" onClick={() => setMenugate(true)} >{NAVBAR_ICON}</button>

            if (auth === LOGGED) {
                return <div className='app_navroot'>
                    {TOPLEFTNAV_DIV}
                    {SidelistIcon}
                    <Portalmodal
                        portaltype={'commonportal'}
                        open={menugate}
                        onClose={() => setMenugate(false)}
                        floatingclose={false}
                        backdropvisible={true}
                        modalstyle={{}}
                        closestyle={{ right: 0 }}
                        floatingclosecolor='#333333'
                    >
                        <div style={{ marginLeft: 10, height: 60, minHeight: 60 }} />
                        <div className='App_linksroot'>
                            {usertype === 'Guest' &&
                                Object.keys(loggedmenuG_mobile).map((menuKey, index) => {
                                    const { link } = loggedmenuG_mobile[menuKey]
                                    return (
                                        <React.Fragment key={menuKey + index}>
                                            <Link className="AppNavItemM" to={link} onClick={offdialog}>{menuKey}</Link>
                                            {SS_LINE}
                                        </React.Fragment>
                                    )
                                })}

                            {(usertype === 'Event' || usertype === 'Wedding') &&
                                Object.keys(loggedmenuWE_mobile).map((menuKey, index) => {
                                    const { link, func, icon } = loggedmenuWE_mobile[menuKey]

                                    // Logout case
                                    if (menuKey === 'Logout') {
                                        return (
                                            <React.Fragment key={menuKey + index}>
                                                {SS_LINE}
                                                <Link id={menuKey} className="AppNavItemM" to={link} onClick={func}>{menuKey}</Link>
                                            </React.Fragment>
                                        )
                                    }

                                    // Normal / Blog / others
                                    return (
                                        <div
                                            key={menuKey + index}
                                            style={{ display: 'flex', flexDirection: 'row', width: '100%', placeItems: 'center', }}
                                            onClick={menuKey === 'Blog' ? func : offdialog}
                                        >
                                            {icon && iconwrapper(icon, mobileiconcss)}
                                            <Link id={menuKey} className="AppNavItemM" to={link} onClick={menuKey === 'Blog' ? func : offdialog} > {menuKey} </Link>
                                        </div>
                                    )
                                })}
                        </div>
                        {/* <div className='App_linksroot'>
                            {usertype === 'Guest'
                                ? Object.keys(loggedmenuG_mobile).map((key, index) => {
                                    const { link } = loggedmenuG_mobile[key]
                                    return [<Link className="AppNavItemM" key={key + index} to={link} onClick={offdialog}>{key}</Link>, SS_LINE]
                                })
                                : (usertype === 'Event' || usertype === 'Wedding')
                                    ? Object.keys(loggedmenuWE_mobile).map((key, index) => {
                                        const { link, func, icon } = loggedmenuWE_mobile[key]
                                        if (key === 'Logout') {
                                            return [SS_LINE, <Link id={`${key}`} className="AppNavItemM" key={key + index} to={link} onClick={key === 'Logout' ? func : offdialog}>{key}</Link>]
                                        }
                                        else if (key === 'Blog') {
                                            // return [<Link className="AppNavItemM" key={key + index} to={link} onClick={func}>{key}</Link>]
                                            return <div style={{ display: 'flex', flexDirection: 'row', width: '100%', placeItems: 'center', }} onClick={() => document.getElementById(key).click()}>
                                                {iconwrapper(icon, mobileiconcss)}
                                                <Link id={`${key}`} className="AppNavItemM" key={key + index} to={link} onClick={func}>{key}</Link>
                                            </div>
                                        }
                                        return <div style={{ display: 'flex', flexDirection: 'row', width: '100%', placeItems: 'center', }} onClick={() => document.getElementById(key).click()}>
                                            {iconwrapper(icon, mobileiconcss)}
                                            <Link id={`${key}`} className="AppNavItemM" key={key + index} to={link} onClick={key === 'Logout' ? func : offdialog}>{key}</Link>
                                        </div>
                                    })
                                    : null}
                        </div> */}
                    </Portalmodal>
                </div>
            }
            else {
                return <div className='app_navroot'>
                    {TOPLEFTNAV_DIV}
                    {SidelistIcon}
                    <Portalmodal
                        portaltype={'commonportal'}
                        open={menugate}
                        onClose={() => setMenugate(false)}
                        floatingclose={false}
                        backdropvisible={true}
                        modalstyle={{}}
                        closestyle={{ right: 0 }}
                        floatingclosecolor='#333333'
                    >
                        <div style={{ marginLeft: 10, height: 60, minHeight: 60 }} />
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', overflowY: 'auto' }}>
                            {Object.keys(unloggedmenu).map((key, index) => {
                                const { link, func } = unloggedmenu[key]
                                if (key === 'Sign Up') {
                                    return [SS_LINE, <Link className="AppNavItemM" key={key + index} to={link} onClick={key === 'Logout' ? func : offdialog}>{key}</Link>]
                                }
                                else if (key === 'Blog') {
                                    return [<Link className="AppNavItemM" key={key + index} to={link} onClick={func}>{key}</Link>]
                                }
                                else {
                                    return [<Link className="AppNavItemM" key={key + index} to={link} onClick={offdialog}>{key}</Link>]
                                }
                            })}
                        </div>
                    </Portalmodal>
                </div>
            }
        }

    }

    // START OF ROUTING DOM --------------------------------------------------
    const Home_dom = (props) => {
        if (auth === LOGGED) {
            return <Homeuser {...props} auth={auth} usertype={usertype} changeOfUsertype={(ut) => { if (ut !== usertype) { setUsertype(ut) } }} />
        }
        else if (auth === LOGOUT) {
            return <UserLogin {...props} />
        }
    }

    const Quote_dom = (props) => {
        return auth === LOGGED && usertype !== 'Guest' ? <UserQuote {...props} /> : <Notfound />
    }

    const Chat_dom = (props) => {
        return auth === LOGGED && usertype !== 'Guest' ? <Inbox  {...props} /> : <Notfound />
    }

    const Userquestion_dom = (props) => {
        return auth === LOGGED && usertype !== 'Guest' ? <UserQuestion  {...props} app_usertype={usertype} hidetopbar={hidetopbar} /> : <Notfound />
    }

    const Eventdiscovery_dom = (props) => {
        return auth === LOGGED && usertype !== 'Guest' && usertype !== 'Wedding' ? <EventDiscovery  {...props} /> : <Notfound />
    }

    const Tool_dom = (props) => {
        if ( usertype === 'Guest') {
            return <Notfound />
        }
        return <Tools {...props} auth={auth} usertype={usertype} wedorevent={usertype} authuser={auth === LOGGED && !( usertype === 'Guest')} />
    }

    const Market_dom = (props) => {
        return <Market {...props} usertype={usertype} wedorevent={usertype} authuser={auth === LOGGED && usertype !== 'Guest'} />
    }

    // const Invitationmaker_dom = (props) => {
    //     return auth === LOGGED && (usertype === 'Wedding' || usertype === 'Event' || usertype === 'Guest') ? <Planning  {...props} name={'Invitation'} /> : null
    // }

    // const Budgetmaker_dom = (props) => {
    //     return auth === LOGGED && (usertype === 'Wedding' || usertype === 'Event' || usertype === 'Guest') ? <Planning {...props} name={'Budget'} /> : null
    // }

    // const Itinerary_dom = (props) => {
    //     return auth === LOGGED && (usertype === 'Wedding' || usertype === 'Event' || usertype === 'Guest') ? <Planning {...props} name={'Itinerary'} /> : null
    // }

    // const Checklist_dom = (props) => {
    //     return auth === LOGGED && (usertype === 'Wedding' || usertype === 'Event' || usertype === 'Guest') ? <Planning {...props} name={'Checklist'} /> : null
    // }

    // const Seatingchart_dom = (props) => {
    //     return auth === LOGGED && (usertype === 'Wedding' || usertype === 'Event' || usertype === 'Guest') ? <Planning {...props} name={'Seatingchart'} hidetopbar={hidetopbar} /> : null
    // }

    // const Qr_dom = (props) => {
    //     return auth === LOGGED && (usertype === 'Wedding' || usertype === 'Event' || usertype === 'Guest') ? <Planning {...props} name={'Qr'} hidetopbar={hidetopbar} /> : null
    // }

    // const Guesttbookbuilder_dom = (props) => {
    //     return auth === LOGGED && (usertype === 'Wedding' || usertype === 'Event' || usertype === 'Guest') ? <Planning {...props} name={'Guestbookv1'} hidetopbar={hidetopbar} /> : null
    // }

    const Planning_dom = (props) => {
        return auth === LOGGED && (usertype === 'Wedding' || usertype === 'Event' || usertype === 'Guest') ? <Planning {...props} name={'Planning'} /> : null
    }

    const Itineraryedit_dom = (props) => {
        return auth === LOGGED && usertype !== 'Guest' && (usertype === 'Wedding' || usertype === 'Event') ? <Itineraryedit {...props} hidetopbar={hidetopbar} /> : null
    }

    const Invitationedit_dom = (props) => {
        return auth === LOGGED && usertype !== 'Guest' && (usertype === 'Wedding' || usertype === 'Event') ? <Invitationedit {...props} hidetopbar={hidetopbar} /> : null
    }

    const Qredit_dom = (props) => {
        return auth === LOGGED && usertype !== 'Guest' && (usertype === 'Wedding' || usertype === 'Event') ? <Qredit {...props} hidetopbar={hidetopbar} /> : null
    }

    const Qrlookup_dom = (props) => {
        return auth === LOGGED && usertype !== 'Guest' && (usertype === 'Wedding' || usertype === 'Event') ? <Qrlookup {...props} hidetopbar={hidetopbar} from='APP' /> : null
    }

    const Seatchartedit_dom = (props) => {
        return auth === LOGGED && usertype !== 'Guest' && (usertype === 'Wedding' || usertype === 'Event') ? <Seatchartedit  {...props} hidetopbar={hidetopbar} /> : null
    }

    const Guestbookv1edit_dom = (props) => {
        return auth === LOGGED && (usertype === 'Wedding' || usertype === 'Event' || usertype === 'Guest') ? <Guestbookv1edit {...props} hidetopbar={hidetopbar} /> : null
    }
    const Checklistedit_dom = (props) => {
        return auth === LOGGED && (usertype === 'Wedding' || usertype === 'Event' || usertype === 'Guest') ? <Checklistedit {...props} hidetopbar={hidetopbar} /> : null
    }

    const Budgetedit_dom = (props) => {
        return auth === LOGGED && (usertype === 'Wedding' || usertype === 'Event' || usertype === 'Guest') ? <Budgetedit {...props} hidetopbar={hidetopbar} /> : null
    }

    const Guestbookcast_dom = (props) => {
        return <Guestbookv1cast {...props} hidetopbar={hidetopbar} />
    }

    const Guestbookmod_dom = (props) => {
        return <Guestbookv1mod {...props} hidetopbar={hidetopbar} />
    }

    const Guestbookv1guest_dom = (props) => {
        return <Guestbookv1 {...props} hidetopbar={hidetopbar} />
    }

    const Guestbook_dom = (props) => {
        return <Guestbook {...props} hidetopbar={hidetopbar} />
    }

    const Guestbookedit_dom = (props) => {
        return <Guestbookedit {...props} hidetopbar={hidetopbar} />
    }

    const Guestbookv1lookup_dom = (props) => {
        return <Guestbookv1lookup {...props} hidetopbar={hidetopbar} />
    }

    const Guestbooklookup_dom = (props) => {
        return <Guestbooklookup {...props} hidetopbar={hidetopbar} />
    }

    const Invitationlookup_dom = (props) => {
        return <Invitationlookup {...props} hidetopbar={hidetopbar} />
    }

    const Timelinelookup_dom = (props) => {
        return <Itinerarylookup {...props} hidetopbar={hidetopbar} from='APP' />
    }

    const Seatchartlookup_dom = (props) => {
        return <Sclookup {...props} hidetopbar={hidetopbar} />
    }

    const Pricelist_dom = (props) => {
        return auth === LOGGED && usertype !== 'Guest' ? <Pricelist {...props} auth={auth} usertype={usertype} /> : <Notfound />
    }

    const Projectgallery_dom = (props) => {
        return auth === LOGGED && usertype !== 'Guest' ? <ProjectGallery {...props} auth={auth} usertype={usertype} token={token} id={id} /> : <Notfound />
    }

    const Weddingvendors_dom = (props) => {
        return auth === LOGGED && usertype !== 'Guest' ? <WeddingVendors {...props} auth={auth} usertype={usertype} /> : <Notfound />
    }

    const Eventvendors_dom = (props) => {
        return auth === LOGGED && usertype !== 'Guest' ? <EventVendors {...props} auth={auth} /> : <Notfound />
    }

    const Userboard_dom = (props) => {
        return auth === LOGGED && usertype !== 'Guest' ? <UserBoard {...props} /> : <Notfound />
    }

    const Favouritevendor_dom = () => {
        return auth === LOGGED && usertype !== 'Guest' ? <UserFavourite /> : <Notfound />
    }

    const Userprofile_dom = (props) => {

        return auth === LOGGED ? <UserProfile {...props} /> : <Notfound />
    }

    const Resetupw_dom = (props) => {
        return auth === LOGOUT ? <Resetpw  {...props} ut={'u'} hidetopbar={hidetopbar} /> : null
    }

    const Usersignup_dom = (props) => {
        return auth === LOGOUT ? <UserSignup {...props} hidetopbar={hidetopbar} /> : null
    }

    const Vendorlookup_dom = (props) => {
        return <Vendorlookup {...props} />
    }

    const Faq_dom = (props) => {
        return <Faq {...props} accttype={'USER'} />
    }

    const Longimg_dom = (props) => {
        return <Gif {...props} hidetopbar={hidetopbar} />
    }

    const Pricelistlookup_dom = (props) => {
        return <Pricelistlookup {...props} hidetopbar={hidetopbar} />
    }

    const Marketlookup_dom = (props) => {
        return <Marketlookup {...props} />
    }

    const Map_dom = (props) => {
        return <Jmap {...props} hidetopbar={hidetopbar} />
    }

    const Collection_dom = (props) => {
        return <Collection {...props} hidetopbar={hidetopbar} />
    }

    const Guestbookhowitworks_dom = (props) => {
        return <Guestbookhowitworks {...props} hidetopbar={hidetopbar} />
    }

    const Comparevenue_dom = (props) => {
        return <Comparevenue {...props} hidetopbar={hidetopbar} />
    }

    const Etsyguestbook_dom = (props) => {
        return <Etsyguestbook {...props} hidetopbar={hidetopbar} />
    }

    const reacthelmet = production ? <Helmet><title>{`${STARTUP_NAME} - Wedding & Event Planning`}</title><meta name="description" content="User Login" /></Helmet> : null

    return <Router history={history} >
        <div id="app-root" >
            {reacthelmet}
            {(auth === LOADING || hidetop) ? null : NavbarHeader()}
            {auth === LOADING
                ? <Loading from='main-app' />
                : <Switch>
                    <Route exact path="/" render={Home_dom} />
                    <Route exact path="/wedding" render={Home_dom} />
                    <Route exact path="/event" render={Home_dom} />
                    <Route exact path="/transaction" render={Quote_dom} />
                    <Route exact path="/chat" render={Chat_dom} />
                    <Route exact path="/profile" render={Userprofile_dom} />
                    <Route exact path="/favourite/vendor" render={Favouritevendor_dom} />
                    <Route exact path="/board" render={Userboard_dom} />
                    <Route exact path="/event/:vt" render={Eventvendors_dom} />

                    <Route exact path="/vendor/:wedorevent/:vt" render={Weddingvendors_dom} />
                    <Route exact path="/pricelist/:wedorevent/:vt" render={Pricelist_dom} />

                    <Route exact path="/projectgallery" render={Projectgallery_dom} />
                    <Route exact path="/promo" render={Pricelist_dom} />
                    <Route exact path="/userquestion" render={Userquestion_dom} />
                    <Route exact path='/eventdiscovery' render={Eventdiscovery_dom} />
                    <Route exact path='/market' render={Market_dom} />

                    <Route exact path='/tools' render={Tool_dom} />
                    <Route exact path='/tools/:app' render={Tool_dom} />
                    <Route exact path='/tools/itinerarybuilder/:id/edit' render={Itineraryedit_dom} />
                    <Route exact path='/tools/invitationbuilder/:id/edit' render={Invitationedit_dom} />
                    <Route exact path='/tools/invitationbuilder/:id/edit' render={Invitationedit_dom} />
                    <Route exact path='/tools/invitationbuilder/:id/edit/:page' render={Invitationedit_dom} />
                    <Route exact path='/tools/qrbuilder/:id/edit' render={Qredit_dom} />
                    {/* <Route exact path='/tools/budgetbuilder' render={Budgetmaker_dom} /> */}
                    {/* <Route exact path='/tools/checklistbuilder' render={Checklist_dom} /> */}
                    {/* <Route exact path='/tools/seatingchartbuilder' render={Seatingchart_dom} /> */}
                    {/* <Route exact path='/tools/guestbookv1builder' render={Guesttbookbuilder_dom} /> */}
                    <Route exact path='/tools/seatingchartbuilder/:id/edit' render={Seatchartedit_dom} />
                    <Route exact path='/tools/guestbookv1builder/:id/edit' render={Guestbookv1edit_dom} />
                    <Route exact path='/tools/checklistbuilder/:id/edit' render={Checklistedit_dom} />
                    <Route exact path='/tools/budgetbuilder/:id/edit' render={Budgetedit_dom} />
                    <Route exact path='/tools/guestbookbuilder/:id/edit' render={Guestbookedit_dom} />

                    <Route exact path='/guestbookv1/:urlhandler/:passcode' render={Guestbookv1guest_dom} /> {/* for guest to key in msg and imgs */}
                    <Route exact path='/guestbookcast/:castno/:urlhandler/:passcode/:gbid' render={Guestbookcast_dom} />
                    <Route exact path='/guestbookmod/:urlhandler/:passcodemod' render={Guestbookmod_dom} />
                    <Route exact path='/guestbooklookupv1/:urlhandler/:passcodemod' render={Guestbookv1lookup_dom} />
                    <Route exact path='/guestbooklookupv1/:urlhandler' render={Guestbookv1lookup_dom} />

                    <Route exact path='/guestbook/:urlhandler/:passcode' render={Guestbook_dom} /> {/* for guest to key in msg and imgs */}
                    <Route exact path='/guestbooklookup/:urlhandler/:modpasscode' render={Guestbooklookup_dom} />

                    <Route exact path='/guestbook/crypto/:urlhandler/:passcode' render={Guestbook_dom} /> {/* for guest to key in msg and imgs */}
                    <Route exact path='/guestbooklookup/crypto/:urlhandler/:passcode' render={Guestbook_dom} /> {/* for guest to key in msg and imgs */}

                    {/*
                    <Route exact path='/tools/qrbuilder' render={Qr_dom} />
                    <Route exact path='/qr/:bannerdesign/:apptype/:url' render={Qr_dom} />
                    <Route exact path='/qr/:bannerdesign/:apptype/:url/:passcode' render={Qr_dom} /> 
                    */}

                    {/* UNAUTH only */}
                    <Route exact path="/signup" render={Usersignup_dom} />
                    {/* ALL */}
                    <Route path="/vendorlookup/:vendorname" render={Vendorlookup_dom} />
                    <Route path="/blog/" exact component={Blog} />
                    <Route path="/blog/:title" exact component={Bpage} />
                    <Route path="/beyond" exact component={Beyond} />
                    <Route path="/beyond/:title" exact component={Bpage} />
                    <Route path="/projectlookup/:project_id" exact component={Projectlookup} />
                    <Route path="/pricelistlookup/:pricelist_id" render={Pricelistlookup_dom} />
                    <Route path="/marketlookup/:marketlisting_id" render={Marketlookup_dom} />
                    <Route path="/about" exact component={About} />
                    <Route path="/user/verify/:email/:verifyingtoken" exact component={UserVerify} />
                    <Route path="/resetpassword/:resettoken" exact component={Resetupw_dom} />
                    <Route path="/faq" exact>{Faq_dom}</Route>
                    <Route path="/Gif" exact>{Longimg_dom}</Route>
                    {/* Planning */}
                    {/* <Route exact path='/planning' render={Planning_dom} /> can be removed*/}

                    {/* Invitation */}
                    <Route path="/invitation/:invitationlookup" exact>{Invitationlookup_dom}</Route>
                    <Route path="/invitation/:invitationlookup/guestuid=:guestuid" exact>{Invitationlookup_dom}</Route>
                    <Route path="/invitation/:invitationlookup/passcode=:passcode" exact>{Invitationlookup_dom}</Route>
                    <Route path="/invitation/:invitationlookup/passcode=:passcode/guestuid=:guestuid" exact>{Invitationlookup_dom}</Route>
                    <Route path="/invitation/:invitationlookup/guestuid=:guestuid/passcode=:passcode" exact>{Invitationlookup_dom}</Route>
                    <Route path="/invitation/:invitationlookup/gallery=:gallery" exact>{Invitationlookup_dom}</Route>
                    <Route path="/invitation/:invitationlookup/guestuid=:guestuid/gallery=:gallery" exact>{Invitationlookup_dom}</Route>
                    <Route path="/invitation/:invitationlookup/passcode=:passcode/gallery=:gallery" exact>{Invitationlookup_dom}</Route>
                    <Route path="/invitation/:invitationlookup/passcode=:passcode/guestuid=:guestuid/gallery=:gallery" exact>{Invitationlookup_dom}</Route>
                    <Route path="/invitation/:invitationlookup/guestuid=:guestuid/passcode=:passcode/gallery=:gallery" exact>{Invitationlookup_dom}</Route>
                    {/* Timeline */}
                    <Route path="/timelinelookup/:urlhandler" exact>{Timelinelookup_dom}</Route>
                    <Route path="/timelinelookup/:urlhandler/passcode=:passcode" exact>{Timelinelookup_dom}</Route>
                    {/* Seatchartlookup */}
                    <Route path='/seatingchartlookup/:urlhandler' exact>{Seatchartlookup_dom}</Route>
                    <Route path='/seatingchartlookup/:urlhandler/passcode=:passcode' exact>{Seatchartlookup_dom}</Route>
                    <Route path='/seatingchartlookup/:urlhandler/:passcode' exact>{Seatchartlookup_dom}</Route>

                    {/* Qr */}
                    <Route path='/qrlookup/:urlhandler/passcode=:passcode' render={Qrlookup_dom} />
                    <Route path='/qrlookup/:urlhandler/:passcode' exact>{Qrlookup_dom}</Route>

                    {/* Visualise Venue, state will not reset if its use this way  */}
                    <Route path="/compare/weddingvenue" exact >{Comparevenue_dom}</Route>

                    {/* for etsy */}
                    <Route path="/etsy/guestbook" exact >{Etsyguestbook_dom}</Route>

                    {/* <Route path="/compare/weddingvenue" exact component={Comparevenue_dom} />
                    resize in this component will lead to state being reset */}

                    {/* Map */}
                    <Route path="/map" render={Map_dom} />

                    {/* Collection */}
                    <Route path="/collection" render={Collection_dom} />

                    {/* Explain Digital Guestbook */}
                    <Route path="/guestbook-how-it-works" render={Guestbookhowitworks_dom} />

                    {/* Not found */}
                    {usertype !== null ? <Route path="*" component={Notfound} /> : null}
                    {auth === LOGOUT ? <Route path="*" component={Notfound} /> : null}
                </Switch>}
            {videorecord_for_socialmedia && !production ? <ScreenRecorder /> : null}
        </div>
    </Router>
}

export default App